export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/MS-82509560adfc42e6f7548968320d5fe7.PNG";